module.exports = __webpack_public_path__ + "img/0032.c0e95644.jpg";